/* eslint-disable react/style-prop-object */
/* eslint-disable max-len */
import React, { FC } from "react";
import Typography from "@mui/material/Typography";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import InstagramIcon from "@mui/icons-material/Instagram";
import { Box, Container, Grid, IconButton, Link } from "@mui/material";
import classes from "./style";

const Footer: FC<{}> = () => {
  const [value, setValue] = React.useState(0);

  return (
    <Container disableGutters maxWidth={false} sx={classes.footer}>
      <Container sx={classes.footerList}>
        <Grid container>
          <Grid item xs={12} md={4}>
            <Typography variant="h6">Plan du site</Typography>
            <ul>
              <li>
                <Link href="/">Accueil</Link>
              </li>
              <li>
                <Link href="/">Je sais où je vais</Link>
              </li>
              <li>
                <Link href="/explorer-le-monde">Explorer le monde</Link>
              </li>
            </ul>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="h6">Assistance</Typography>
            <ul>
              <li>
                <Typography variant="body2"><a href="mailto:contact@caladre.com">Contact</a></Typography>
              </li>
              <li>
                <Typography variant="body2"><a href="mailto:digital@caladre.com">Presse</a></Typography>
              </li>
              <li>
                <Typography variant="body2"><a href="mailto:partenariat@caladre.com ">Partenariat</a></Typography>
              </li>
            </ul>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="h6">Légal</Typography>
            <ul>
              <li>
                <Link href="/politique-cookie">Politique de cookies</Link>
              </li>
              <li>
                <Link href="/protection-des-donnees">Politique de confidentialité</Link>
              </li>
              <li>
                <Link href="/conditions-generales-utilisation">Mentions légales</Link>
              </li>
            </ul>
          </Grid>
        </Grid>
      </Container>
      <Container sx={classes.footerBaseline}>
        <Typography variant="body2">© Caladre {new Date().getFullYear()}</Typography>
      </Container>
    </Container>
  );
};

export default Footer;
